import React from 'react';
import { glassPanelStyle } from '../../theme';

/**
 * Full-height, app-style page (Brain, Playground, ...) laid out as floating
 * Liquid Glass panels over the shell gradient — same 12px gutter, radius and
 * surface as AppSidebar / AppFooter, so these screens read as part of the
 * shell instead of a full-bleed white canvas.
 *
 * List/admin pages keep using AppPageLayout + Cards; use this one when the
 * page is a fixed-height workspace with its own internal scroll regions.
 */
export const GlassWorkspace: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  // `height: '100%'`, not `100vh`: this renders inside App.tsx's scrollable
  // content region (viewport minus the footer), see AppPageLayout.
  <div style={{ height: '100%', padding: 12, display: 'flex', gap: 12, boxSizing: 'border-box', minHeight: 0 }}>
    {children}
  </div>
);

interface GlassPanelProps {
  children: React.ReactNode;
  /** Fixed width in px. Omit to let the panel take the remaining space. */
  width?: number;
}

/** One glass column of a GlassWorkspace; content scrolls inside it, never the page. */
export const GlassPanel: React.FC<GlassPanelProps> = ({ children, width }) => (
  <div
    style={{
      ...glassPanelStyle,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minWidth: 0,
      minHeight: 0,
      ...(width ? { width, flexShrink: 0 } : { flex: 1 }),
    }}
  >
    {children}
  </div>
);
